import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: '/qq-mobile',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                title: '首页'
            }
        },
        {
            path: '/hisTrack', // hisTrack?sessionId=&clientType=wxmp&systemType=andriod   , clientType (1.wxmp 小程序, 2:andriod, 3:ios) systemType (1. android 2.ios)
            name: 'HisTrackIndex',
            component: () =>
                import(
                    /* webpackChunkName: "Trajectory-Group" */ './views/HisTrack/Index.vue'
                ),
            redirect: { name: 'HisTrack' },
            meta: {
                title: '轨迹首页'
            },
            children: [
                {
                    path: '',
                    name: 'HisTrack',
                    component: () =>
                        import(
                            /* webpackChunkName: "Trajectory-Group" */ './views/HisTrack/Home.vue'
                        )
                },
                {
                    path: 'queryRecord',
                    name: 'QueryRecord',
                    component: () =>
                        import(
                            /* webpackChunkName: "Trajectory-Group" */ './components/hisTrack/QueryRecord.vue'
                        )
                },
                {
                    path: 'map',
                    name: 'Map',
                    component: () =>
                        import(
                            /* webpackChunkName: "Trajectory-Group" */ './views/HisTrack/Map.vue'
                        )
                }
            ]
        },
        {
            path: '/feedback',
            name: 'feedback',
            component: () =>
                import(
                    /* webpackChunkName: "FeedBack" */ './views/Feedback/index.vue'
                ),
            meta: {
                title: '问题与反馈'
            }
        },
        {
            path: '/truck-home',
            name: 'truckHome',
            component: () =>
                import(
                    /* webpackChunkName: "FeedBack" */ './views/truckHome/index.vue'
                ),
            meta: {
                title: '查车首页'
            }
        },
        {
            path: '/search-car',
            name: 'searchCar',
            component: () =>
                import(
                    /* webpackChunkName: "FeedBack" */ './views/truckHome/searchCar.vue'
                ),
            meta: {
                title: '搜索车牌'
            }
        },
        {
            path: '/protocal',
            name: 'protocal',
            component: () =>
                import(
                    /* webpackChunkName: "FeedBack" */ './views/Protocal/index.vue'
                ),
            meta: {
                title: 'protocal'
            }
        },
        {
            path: '/vip-home',
            name: 'vip-home',
            component: () => import('./views/truckHome/vip/index.vue'),
            meta: {
                title: 'vip-home'
            }
        },
        {
            path: '/attestation-example',
            name: 'attestation-example',
            component: () => import('./views/truckHome/vip/example.vue'),
            meta: {
                title: 'attestation-example'
            }
        },
        {
            path: '/payIssue', // ios 支付问题
            name: 'payIssue',
            component: () =>
                import(
                    /* webpackChunkName: "about" */ './views/PayIssue/index.vue'
                ),
            meta: {
                title: 'payIssue'
            }
        },
        {
            path: '/recall-integral',
            name: 'recall-integral',
            component: () => import('./views/recall/integral/index.vue'),
            meta: {
                title: 'recall-integral'
            }
        },
        {
            path: '/recall-download',
            name: 'recall-download',
            component: () => import('./views/recall/integral/download.vue'),
            meta: {
                title: 'recall-download'
            }
        },
        {
            path: '/integral-turntable',
            name: 'integral-turntable',
            component: () => import('./views/integral-turntable/index.vue'),
            meta: {
                title: 'integral-turntable'
            }
        },
        {
            path: '/select-identity',
            name: 'select-identity',
            component: () => import('./views/attestation/select-identity.vue'),
            meta: {
                title: 'select-identity'
            }
        },
        {
            path: '/car-main',
            name: 'car-main',
            component: () => import('./views/attestation/car-main.vue'),
            meta: {
                title: 'car-main'
            }
        },
        {
            path: '/vehicle-owner',
            name: 'vehicle-owner',
            component: () => import('./views/attestation/vehicle-owner.vue'),
            meta: {
                title: 'vehicle-owner'
            }
        },
        {
            path: '/access-net-reason',
            name: 'access-net-reason',
            component: () => import('./views/accessNetReason/index.vue'),
            meta: {
                title: '办理入网'
            }
        },
        {
            path: '/download-app',
            name: 'download-app',
            component: () => import('./views/downApp/index.vue'),
            meta: {
                title: '下载App'
            }
        },
        {
            path: '/download-app2',
            name: 'download-app2',
            component: () => import('./views/downApp/other-index.vue'),
            meta: {
                title: '下载App'
            }
        },
        {
            path: '/privacy-argeement',
            name: 'privacy-argeement',
            component: () => import('./views/privacyArgeement/index.vue'),
            meta: {
                title: 'privacy-argeement'
            }
        },
        {
            path: '/user-argeement',
            name: 'user-argeement',
            component: () => import('./views/userArgeement/index.vue'),
            meta: {
                title: 'user-argeement'
            }
        },
        {
            // 认证选择身份
            path: '/auth-identity',
            name: 'auth-identity',
            component: () => import('./views/authentication/auth-identity.vue'),
            meta: {
                title: '身份选择'
            }
        },
        {
            // 认证方式
            path: '/auth-type',
            name: 'auth-type',
            component: () => import('./views/authentication/auth-type.vue'),
            meta: {
                title: '认证方式'
            }
        },
        {
            // 上传车架号
            path: '/vin-authentication',
            name: 'vin-authentication',
            component: () => import('./views/vin-authentication/index.vue'),
            meta: {
                title: '车辆授权'
            }
        },
        {
            // 上传车架号
            path: '/auth-status',
            name: 'auth-status',
            component: () =>
                import('./views/vin-authentication/auth-status.vue'),
                meta: {
                    title: ''
                }
        },
        {
            // 上传车架号
            path: '/point-rule',
            name: 'point-rule',
            component: () =>
                import('./views/point-rule/index.vue'),
                meta: {
                    title: '签到领积分'
                }
        }
    ]
})
